import React, { Component } from 'react';
import { withRouter } from 'utilities';
import { useAuth } from 'auth_context';
import { Loading } from 'components';
import CityAutocomplete from 'components/CityAutocomplete';

class AdminOrgsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			orgs: [],
			deleting: null,
			expandedId: null,
			expandedOrgData: null,
			expandedLoading: false,
			expandedSaving: false,
			expandedSaved: false,
			closingId: null,
			closingOrgData: null,
			prefills: null,
			createModalOpen: false,
			createForm: { name: '', city: '', state: '', country: '', lat: null, lng: null, url: '', public_email: '', donation_method1: '' },
			createSaving: false,
		};
	}

	componentDidMount() {
		this.fetchOrgs();
	}

	fetchOrgs = async () => {
		this.setState({ loading: true });
		const response = await this.props.auth.authFetch('/api/admin/orgs/');
		const data = await response.json();
		this.setState({ orgs: data.orgs || [], loading: false });
	};

	toggleExpand = async orgId => {
		const { expandedId, expandedOrgData } = this.state;

		if (expandedId === orgId) {
			// Closing the currently open card
			this.setState({
				expandedId: null,
				closingId: orgId,
				closingOrgData: expandedOrgData,
			});
			setTimeout(() => this.setState({ closingId: null, closingOrgData: null, expandedOrgData: null }), 450);
			return;
		}

		// Switching to a different card — buffer the outgoing data
		this.setState({
			expandedId: orgId,
			expandedOrgData: null,
			expandedLoading: true,
			expandedSaved: false,
			closingId: expandedId,
			closingOrgData: expandedOrgData,
		});
		setTimeout(() => this.setState({ closingId: null, closingOrgData: null }), 450);

		let { prefills } = this.state;
		if (!prefills) {
			const res = await this.props.auth.authFetch('/api/get_prefills/');
			prefills = await res.json();
			this.setState({ prefills });
		}

		const response = await this.props.auth.authFetch(`/api/get_org_details/${orgId}/`);
		const data = await response.json();
		this.setState({ expandedOrgData: data.org, expandedLoading: false });
	};

	updateField = (fieldName, value, isPublic) => {
		const expandedOrgData = { ...this.state.expandedOrgData };
		if (isPublic) {
			expandedOrgData[fieldName] = { ...expandedOrgData[fieldName], is_public: value };
		} else {
			expandedOrgData[fieldName] = { ...expandedOrgData[fieldName], value };
		}
		this.setState({ expandedOrgData });
	};

	saveExpanded = async () => {
		const { expandedId, expandedOrgData } = this.state;
		this.setState({ expandedSaving: true });

		const response = await this.props.auth.authFetch(`/api/submit_org_details/${expandedId}/`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(expandedOrgData),
		});
		const data = await response.json();

		if (data.success) {
			const newName = expandedOrgData.name?.value;
			if (newName) {
				this.setState(prev => ({
					orgs: prev.orgs.map(o => (o.id === expandedId ? { ...o, name: newName } : o)),
				}));
			}
			this.setState({ expandedSaving: false, expandedSaved: true }, () =>
				setTimeout(() => this.setState({ expandedSaved: false }), 3000)
			);
		} else {
			this.setState({ expandedSaving: false });
		}
	};

	handleDelete = async (orgId, orgName) => {
		if (!window.confirm(`Delete "${orgName}"? This cannot be undone.`)) return;

		this.setState({ deleting: orgId });
		const response = await this.props.auth.authFetch(`/api/admin/orgs/${orgId}/`, {
			method: 'DELETE',
		});
		const data = await response.json();

		if (data.success) {
			this.setState(prev => ({
				orgs: prev.orgs.filter(o => o.id !== orgId),
				deleting: null,
				expandedId: prev.expandedId === orgId ? null : prev.expandedId,
			}));
		} else {
			alert('Delete failed.');
			this.setState({ deleting: null });
		}
	};

	openCreateModal = () => {
		this.setState({
			createModalOpen: true,
			createForm: { name: '', city: '', state: '', country: '', lat: null, lng: null, url: '', public_email: '', donation_method1: '' },
		});
	};

	closeCreateModal = () => this.setState({ createModalOpen: false });

	selectCity = ({ city, state, country, lat, lng }) => {
		this.setState(prev => ({
			createForm: { ...prev.createForm, city, state, country, lat, lng },
		}));
	};

	updateCreateForm = (field, value) => {
		this.setState(prev => ({ createForm: { ...prev.createForm, [field]: value } }));
	};

	createOrg = async () => {
		const { createForm } = this.state;
		if (!createForm.name.trim()) return;

		this.setState({ createSaving: true });
		try {
			const response = await this.props.auth.authFetch('/api/admin/orgs/', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(createForm),
			});
			const data = await response.json();

			if (data.success) {
				this.setState({ createSaving: false, createModalOpen: false });
				await this.fetchOrgs();
			} else {
				console.error('Create org failed:', data);
				alert(data.error || 'Failed to create org.');
				this.setState({ createSaving: false });
			}
		} catch (e) {
			console.error('Create org exception:', e);
			alert('An error occurred.');
			this.setState({ createSaving: false });
		}
	};

	renderFields = (data) => {
		const { prefills } = this.state;
		if (!data) return null;

		return Object.keys(data).map(fieldName => {
			const field = data[fieldName];

			let input;
			if (fieldName === 'description') {
				input = (
					<textarea
						className="admin-org-field-input admin-org-field-textarea"
						value={field.value || ''}
						onChange={e => this.updateField(fieldName, e.target.value, false)}
					/>
				);
			} else if (fieldName === 'state') {
				input = (
					<select
						className="admin-org-field-select"
						value={field.value || ''}
						onChange={e => this.updateField(fieldName, e.target.value, false)}
					>
						<option value="">—</option>
						{(prefills?.states || []).map(s => (
							<option key={s} value={s}>
								{s}
							</option>
						))}
					</select>
				);
			} else if (fieldName === 'country') {
				input = (
					<select
						className="admin-org-field-select"
						value={field.value || ''}
						onChange={e => this.updateField(fieldName, e.target.value, false)}
					>
						<option value="">—</option>
						{(prefills?.countries || []).map(c => (
							<option key={c} value={c}>
								{c}
							</option>
						))}
					</select>
				);
			} else {
				input = (
					<input
						className="admin-org-field-input"
						value={field.value || ''}
						onChange={e => this.updateField(fieldName, e.target.value, false)}
					/>
				);
			}

			return (
				<div key={fieldName} className="admin-org-field-row">
					<span className="admin-org-field-label">{field.display_name}</span>
					<div className="admin-org-field-value">{input}</div>
					<label className="admin-org-field-public" title="Visible to public?">
						<input
							type="checkbox"
							className="org-detail-public-checkbox"
							checked={field.is_public || false}
							onChange={e => this.updateField(fieldName, e.target.checked, true)}
						/>
					</label>
				</div>
			);
		});
	};

	render() {
		const { loading, orgs, deleting, expandedId, expandedOrgData, expandedLoading, expandedSaving, expandedSaved, closingId, closingOrgData, createModalOpen, createForm, createSaving } =
			this.state;

		if (loading) return <Loading loading />;

		return (
			<div className="org-info-container">
				<div style={{ display: 'flex', alignItems: 'baseline', gap: '18px' }}>
					<h1 style={{ margin: 0 }}>All Organizations</h1>
					<span
						style={{
							fontStyle: 'italic',
							color: 'rgba(220,220,220,0.7)',
							fontSize: '20px',
							position: 'relative',
							bottom: '2px',
						}}
					>
						[Admin]
					</span>
				</div>

				{createModalOpen && (
					<div className="modal-overlay" onClick={this.closeCreateModal}>
						<div className="admin-create-modal" onClick={e => e.stopPropagation()}>
							<h2 style={{ margin: '0 0 24px' }}>Add Organization</h2>
							<div className="admin-create-fields">
								{[
									{ label: 'Name', key: 'name', placeholder: 'Organization name', required: true },
								].map(({ label, key, placeholder, required }) => (
									<div key={key} className="admin-create-field">
										<label className="admin-create-label">
											{label}{required && <span className="admin-create-required"> *</span>}
										</label>
										<input
											className="admin-create-input"
											value={createForm[key]}
											placeholder={placeholder}
											onChange={e => this.updateCreateForm(key, e.target.value)}
										/>
									</div>
								))}
								<div className="admin-create-field">
									<label className="admin-create-label">City</label>
									<CityAutocomplete
										placeholder="Search city…"
										onSelect={this.selectCity}
									/>
									{createForm.city && (
										<span className="admin-create-city-meta" style={{ marginTop: '4px' }}>
											Selected: {[createForm.city, createForm.state, createForm.country].filter(Boolean).join(', ')}
										</span>
									)}
								</div>
								{[
									{ label: 'Website', key: 'url', placeholder: 'https://…' },
									{ label: 'Email', key: 'public_email', placeholder: 'contact@…' },
									{ label: 'Donation Method', key: 'donation_method1', placeholder: 'e.g. PayPal, Venmo, cheque…' },
								].map(({ label, key, placeholder }) => (
									<div key={key} className="admin-create-field">
										<label className="admin-create-label">{label}</label>
										<input
											className="admin-create-input"
											value={createForm[key]}
											placeholder={placeholder}
											onChange={e => this.updateCreateForm(key, e.target.value)}
										/>
									</div>
								))}
							</div>
							<div className="admin-create-footer">
								<button className="admin-org-btn" onClick={this.closeCreateModal}>
									Cancel
								</button>
								<button
									className="admin-org-btn admin-org-btn--save"
									onClick={this.createOrg}
									disabled={createSaving || !createForm.name.trim()}
								>
									{createSaving ? 'Creating…' : 'Create Org'}
								</button>
							</div>
						</div>
					</div>
				)}
				<div className="admin-org-list">
					{orgs.length === 0 && (
						<p style={{ color: 'rgba(255,255,255,0.5)' }}>No organizations found.</p>
					)}
					{orgs.map((org, i) => {
						const isExpanded = expandedId === org.id;
						const isClosing = closingId === org.id;
						const cardData = isExpanded ? expandedOrgData : (isClosing ? closingOrgData : null);

						return (
							<div key={org.id} className={`admin-org-card ${isExpanded ? 'expanded' : ''}`}>
								<div className="admin-org-row">
									<div className="admin-org-info">
										<span className="admin-org-name">{org.name}</span>
										<span className="admin-org-meta">
											{[org.city, org.state].filter(Boolean).join(', ')}
											{' · '}
											{org.user_count} {org.user_count === 1 ? 'user' : 'users'}
											{org.users.length > 0 && ` (${org.users.join(', ')})`}
										</span>
									</div>
									<div className="admin-org-actions">
										<button
											className={`admin-org-btn ${isExpanded ? 'admin-org-btn--active' : 'admin-org-btn--edit'}`}
											onClick={() => this.toggleExpand(org.id)}
										>
											{isExpanded ? 'Close' : 'Edit'}
										</button>
										<button
											className="admin-org-btn admin-org-btn--delete"
											onClick={() => this.handleDelete(org.id, org.name)}
											disabled={deleting === org.id}
										>
											{deleting === org.id ? '…' : 'Delete'}
										</button>
									</div>
								</div>

								<div className="admin-org-expand">
									<div className="admin-org-expand-inner">
										<div className="admin-org-expand-content">
											{expandedLoading && isExpanded ? (
												<p className="admin-org-expand-loading">Loading…</p>
											) : (
												<>
													<div className="admin-org-fields-header">
														<span className="admin-org-field-col-label">
															Field
														</span>
														<span className="admin-org-field-col-value">
															Value
														</span>
														<span className="admin-org-field-col-public">
															Public
														</span>
													</div>
													<div className="admin-org-fields">
														{this.renderFields(cardData)}
													</div>
													<div className="admin-org-expand-footer">
														{expandedSaved && isExpanded && (
															<span className="admin-org-saved-msg">
																Saved ✓
															</span>
														)}
														<button
															className="admin-org-btn admin-org-btn--save"
															onClick={this.saveExpanded}
															disabled={expandedSaving || !isExpanded}
														>
															{expandedSaving ? 'Saving…' : 'Save Changes'}
														</button>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
							</div>
						);
					})}
					<button className="admin-org-add-btn" onClick={this.openCreateModal} title="Add organization">
						+
					</button>
				</div>
			</div>
		);
	}
}

const AdminOrgs = props => {
	const auth = useAuth();
	return <AdminOrgsPage {...props} auth={auth} />;
};

export default withRouter(AdminOrgs);
